<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
    <v-card class="elevation-11">
      <v-card-text>
        <span class="heading">
          <h2>Students</h2>
          <a href="#" @click="$router.push('/admin')" class="ml-4">admin >></a>
        </span>

      <div class="arrows">(Click on arrows to update status)</div>

        <h5 class="mb-3">Active students</h5>
        
        <div v-for="student in activeStudents" :key="student.userId">
          <p>
            <i class="material-icons mr-3"
              @click="changeStatus(student)">
              vertical_align_bottom
            </i>
            <span class="edit" @click="edit(student)">
              {{ student.name }}
            </span>
          </p>
        </div>
        <br/>

      <h5 class="mb-3">Inactive students</h5>

        <div v-for="(student, index) in inActiveStudents" :key="index" class="students">
            <p v-if="student.userId !== $store.state.adminId">
                <i class="material-icons mr-3"
                  @click="changeStatus(student)">
                  vertical_align_top
                </i>
                <span class="edit" @click="edit(student)">
                  {{ student.name }}
                </span>
            </p>
        </div>

      </v-card-text>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    activeStudents() {
      return this.$store.getters.getStudents.filter(el => el.isActive)
    },
    inActiveStudents() {
      return this.$store.getters.getStudents.filter(el => !el.isActive)
    }
  },
  methods: {
    changeStatus(student) {
      const fullname = student.fname + " " + student.lname
      const isActive = student.isActive
      const user = {
        isActive: isActive,
        documentId: student.docId
      }
      this.$store.dispatch("updateUserStatus", user)
    },
    getFullname(student) {
      return student.fname + " " + student.lname
    },
    edit(objStudent) {
      this.$router.push({
        name: 'editStudent',
        params: { student: objStudent }
      })
    }
  }
}
</script>

<style scoped>
.arrows {
  margin-bottom: 20px;
}
h2 {
  font-size: 1.4rem;
  font-weight: bold;
}

h5 {
  font-size: 1rem;
}
p {
  margin: 5px;
  align-items: baseline;
}

.heading{
  display: inline-flex;
  align-items: baseline;
}

.edit {
  text-decoration: underline;
  cursor: pointer;
}
</style>